import React from 'react'
import { Box, Td, Tr, Tbody, TableContainer, Table, Thead, Th, Text } from '@chakra-ui/react'
import moment from 'moment'

export default function RecurringPaymentTable({ data }) {
    return (
        <Box mt={1} className='custom_table_wrapper report-table'>
            <TableContainer>
                <Table variant="striped">
                    <Thead>
                        <Tr>
                            <Th>Party</Th>
                            <Th>Txn Count</Th>
                            <Th>Balance</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data?.map((item, index) => {
                            return (
                                <Tr key={index}>
                                    <Td>
                                        <Text className="font-poppins table_text">{item.Party}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item['Txn Count']}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">₹{item.Balance}</Text>
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    )
}
